import { render, staticRenderFns } from "./PaymentChannelChangeModal.vue?vue&type=template&id=036c06a4"
import script from "./PaymentChannelChangeModal.vue?vue&type=script&lang=js"
export * from "./PaymentChannelChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports